import { format, parse, Locale } from 'date-fns';
import { inject } from 'mobx-react';
import * as React from 'react';
import LanguageStore from '../../stores/LanguageStore';
import BranchOpenTime from './BranchOpenTime';
import { SpecialHour } from '../common/ReservationInterfaces';

interface BranchSpecialHoursProps {
  specialHours?: SpecialHour[];
  languageStore?: LanguageStore;
}

class BranchSpecialHours extends React.Component<BranchSpecialHoursProps> {
  public render() {
    const {
      specialHours,
      languageStore: { currentLocale }
    } = this.props;

    return sortByStartDate(specialHours).map((hour, index) => (
      <p key={index}>
        {formatNoYear(hour.startDate, currentLocale)}
        {hour.startDate !== hour.endDate && <span>–{formatNoYear(hour.endDate, currentLocale)} </span>}
        <BranchOpenTime hour={hour} displayOpenText={true} />
      </p>
    ));
  }
}

const formatNoYear = (date: string, currentLocale: Locale): string => {
  return format(parse(date, 'yyyy-MM-dd', Date.now()), 'dd.MM', { locale: currentLocale });
};

const sortByStartDate = (hours: SpecialHour[]): SpecialHour[] => {
  return hours.slice().sort((h1, h2) => h1.startDate.localeCompare(h2.startDate));
};

export default inject('languageStore')(BranchSpecialHours);
